import React from 'react';
import cx from 'classnames';
import ReactHtmlParser, {convertNodeToElement} from 'react-html-parser';
import styles from './HtmlText.module.scss';
import {createDataTestId} from '../../../utils/dataTestId';
import {getLang} from '../../../Localization';

interface HTMLTextProps {
    content: string;
    linkData?: any[];
    componentClasses?: string;
    onLinkClick?: (linkData) => void;
    isPriorityShop?: boolean;
}

export const HTMLText = ({
    content,
    linkData,
    onLinkClick,
    componentClasses,
    isPriorityShop = false
}: HTMLTextProps) => {
    const replace = (node, index: number) => {
        if (node?.attribs?.ishyperlink) {
            return handleMarkUpLink(node);
        } else if (node?.attribs?.href?.includes('priority:priform')) {
            return handleMarkDownLinks(node);
        } else if (node?.type === 'tag' && node?.name === 'a' && node?.attribs?.href) {
            return handleExternalLinks(node);
        }
        return convertNodeToElement(node, index, replace);
    };

    //links has HTML
    const handleMarkDownLinks = node => {
        const {attribs, children} = node;
        return (
            <a
                href="#"
                onClick={() => {
                    onLinkClick && onLinkClick(null);
                    window['common']?.onLinkClick(attribs?.href);
                }}
                color="primary"
            >
                {children[0]?.data}
            </a>
        );
    };

    //Links handled in server thats includes LinkData
    const handleMarkUpLink = ({attribs, children}) => {
        return (
            <a onClick={() => onLinkClick(linkData[attribs.lnkindex].linkData)} color="primary">
                {children[0]?.data}
            </a>
        );
    };

    //External links
    const handleExternalLinks = ({attribs, children}) => {
        const hrf = attribs?.href;
        const isAnchor = hrf?.startsWith('#');

        return (
            <a href={hrf} target={isAnchor ? '' : '_blank'}>
                {children[0]?.data}
            </a>
        );
    };
    const options = {
        transform: replace
    };

    const prepareHyperlinkMarkup = (text, linkData) => {
        let lastLen = 0;

        return linkData.map((link, i) => {
            const linkFrom = link.from;
            const beforeLinkText = text.substring(lastLen, linkFrom);
            lastLen = linkFrom + link.len;

            let fixText = `${beforeLinkText} <a lnkindex=${i} href="#" isHyperLink=true>${link.title}</a>`;
            if (i === linkData.length - 1) {
                fixText += `<span>${text.substring(lastLen, text.length)}</span>`;
            }
            return fixText;
        });
    };

    const markup = linkData && linkData.length > 0 && prepareHyperlinkMarkup(content, linkData);
    let fixContent = markup ? markup.join('') : content;
    fixContent = fixContent.replace('<body>', '<div>').replace('</body>', '</div>');

    // If isPriorityStore is true, replace "[prioritystore]" with a clickable link
    if (isPriorityShop) {
        const priorityStoreLink = getLang() == '1' ? 'https://shop.priority-software.com/' : 'https://shop.priority-software.com/en';
        
        fixContent = fixContent.replace(
            /\[priorityshop\]/gi,
            `<a href="${priorityStoreLink}">https://shop.priority-software.com</a>`
        );
    }

    return (
        <div
            className={cx(styles.container, componentClasses)}
            {...createDataTestId('html-text-markup', false)}
        >
            {ReactHtmlParser(fixContent, options)}
        </div>
    );
};
